import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from './authConfig'
import { setMsalInstance } from './services/authService'
import './index.css'
import App from './App.tsx'

// Initialize auth service with MSAL instance
setMsalInstance(msalInstance);

// Handle redirect response from Azure AD
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      console.log('Login successful:', response.account);
    }
  }).catch((error) => {
    console.error('Authentication error:', error);
  });

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>,
  );
});
